const MAX_BADGE_PHOTO_SIZE_BYTES = 4 * 1024 * 1024;
const ALLOWED_MIME_TYPES = ['image/jpeg', 'image/png'];
const TARGET_WIDTH = 720;
const TARGET_HEIGHT = 900;

const fileToObjectUrl = (file) => new Promise((resolve, reject) => {
  const objectUrl = URL.createObjectURL(file);
  const image = new Image();

  image.onload = () => resolve({ image, objectUrl });
  image.onerror = () => {
    URL.revokeObjectURL(objectUrl);
    reject(new Error('تعذر قراءة الصورة المحددة'));
  };

  image.src = objectUrl;
});

const sanitizeFileName = (name) => String(name || 'badge-photo')
  .replace(/\.[^/.]+$/, '')
  .replace(/[^a-zA-Z0-9-_]+/g, '-')
  .replace(/-+/g, '-')
  .replace(/^-|-$/g, '')
  .toLowerCase() || 'badge-photo';

export const validateBadgePhoto = (file) => {
  if (!file) {
    throw new Error('الرجاء اختيار صورة للموظف');
  }

  if (!ALLOWED_MIME_TYPES.includes(file.type)) {
    throw new Error('الصيغ المسموحة فقط: JPG, JPEG, PNG');
  }

  if (file.size > MAX_BADGE_PHOTO_SIZE_BYTES) {
    throw new Error('حجم الصورة يجب أن يكون أقل من 4 ميغابايت');
  }
};

export const prepareBadgePhoto = async (file) => {
  validateBadgePhoto(file);

  const { image, objectUrl } = await fileToObjectUrl(file);

  try {
    const canvas = document.createElement('canvas');
    canvas.width = TARGET_WIDTH;
    canvas.height = TARGET_HEIGHT;

    const context = canvas.getContext('2d');
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, TARGET_WIDTH, TARGET_HEIGHT);

    const scale = Math.max(TARGET_WIDTH / image.width, TARGET_HEIGHT / image.height);
    const drawWidth = image.width * scale;
    const drawHeight = image.height * scale;
    const x = (TARGET_WIDTH - drawWidth) / 2;
    const y = (TARGET_HEIGHT - drawHeight) / 2;

    context.drawImage(image, x, y, drawWidth, drawHeight);

    const blob = await new Promise((resolve, reject) => {
      canvas.toBlob(
        (createdBlob) => {
          if (createdBlob) {
            resolve(createdBlob);
            return;
          }

          reject(new Error('تعذر تجهيز الصورة للبطاقة'));
        },
        'image/jpeg',
        0.92
      );
    });

    const nextFile = new File(
      [blob],
      `${sanitizeFileName(file.name)}.jpg`,
      { type: 'image/jpeg' }
    );

    const previewUrl = URL.createObjectURL(blob);

    return {
      file: nextFile,
      previewUrl
    };
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
};

export default prepareBadgePhoto;
